<script>
	export let maxValue = 100;
	export let greenPercentage = 5;
	export let yellowPercentage = 12.5;
	export let redPercentage = 40;

	export let greenLabel = '';
	export let yellowLabel = '';
	export let redLabel = '';
</script>

<style>
	.progress,
	.progress-bar {
		height: 4.5rem;
	}

	.progress {
		position: relative;
	}

	.progress-bar {
		position: absolute;
	}

	.progress-bar strong {
		font-size: 0.7rem;
	}

	.group1 {
		margin-right: 0.5rem;
		background: rgb(0, 105, 12);
		background: linear-gradient(
			90deg,
			rgba(0, 105, 12, 1) 0%,
			rgb(175, 172, 12) 100%
		);
	}
	.group2 {
		margin-right: 0.5rem;
		background: linear-gradient(
			90deg,
			rgb(175, 172, 12) 0%,
			rgb(238, 204, 10) 100%
		);
	}

	.group3 {
		background: linear-gradient(
			90deg,
			rgb(238, 204, 10) 0%,
			rgb(250, 54, 19) 15%,
			rgba(250, 10, 12, 1) 100%
		);
	}

	.shrinker {
		background-color: gray;
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
	}

	.percentages-timeline {
		position: relative;
		height: 1.3rem;
	}

	.percentages-timeline span {
		position: absolute;
		color: black;
		font-size: 0.7rem;
	}
</style>

<div class="progress" aria-valuemax={maxValue}>
	<div style="width: {5}%; left: 0;" class="progress-bar group1">
		<strong>Q4<br>hr</strong>
	</div>
	<div
		style="width: {7.5}%; left: {greenPercentage + 0.5}%;"
		class="progress-bar group2">
		<strong>Q1 vs<br>Q4 hr</strong>
	</div>
	<div style="width: {87.5}%; left: {yellowPercentage + 1}%;" class="progress-bar group3">
		<strong>Q1<br>hr</strong>
	</div>
	<div class="shrinker" />
</div>

<div class="percentages-timeline">
	<span>0%</span>
	<span style="left: {greenPercentage - 1}%">2%</span>
	<span style="left: {greenPercentage + yellowPercentage - 5}%">5%</span>
	<span style="right: 0">40%</span>
</div>

<!-- <div class="container mt-1">
	<div class="row no-gutters">
		<div class="col-1 text-center">Q1 <small>hr</small></div>
		<div class="col-3 text-center">Q1 vs Q4 <small>hrs</small></div>
		<div class="col-8 text-center">Q1 <small>hr</small></div>
	</div>
</div> -->